/* ============================================================
   Atelier Sauli — PDP Monochrome Tome 1 — interactions
   Port de pdp-monochrome-tome1-ete-preview-v3.html (sans la
   logique bundle, gérée par l'app Katching).
   ============================================================ */
(function () {
  'use strict';

  function eur(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  function init() {
    if (!document.querySelector('.as-pdp')) return;
    var root = document; // sections multiples : on requête tout le document

    /* --- Barre livraison offerte --- */
    var buy = document.getElementById('as-pdp-buy');
    var THRESHOLD = buy ? parseFloat(buy.getAttribute('data-threshold')) || 45 : 45;
    var basePrice = buy ? parseFloat(buy.getAttribute('data-price')) || 0 : 0;
    function updateProgress(price) {
      var fill = document.getElementById('asFill');
      var label = document.getElementById('asPlabel');
      var prog = document.getElementById('asProg');
      if (!fill || !label || !prog) return;
      var pct = Math.min(price / THRESHOLD * 100, 100);
      fill.style.width = pct + '%';
      if (price >= THRESHOLD) {
        prog.classList.add('done');
        label.innerHTML = '<b>Livraison STANDARD OFFERTE</b> — c\'est dans la poche';
      } else {
        prog.classList.remove('done');
        label.innerHTML = 'Plus que <b>' + eur(THRESHOLD - price) + '</b> et la livraison t\'est offerte';
      }
    }
    updateProgress(basePrice);

    /* --- Sélecteur de packs (NATIF : highlight + prix + barre port + câblage ATC) --- */
    var bundles = document.getElementById('asBundles');
    if (bundles) {
      var opts = Array.prototype.slice.call(bundles.querySelectorAll('.opt'));
      var vopts = Array.prototype.slice.call(bundles.querySelectorAll('.as-vopt'));
      var atcForm = document.getElementById('asProductForm');
      function selectedVopt() { return bundles.querySelector('.as-vopt.sel') || vopts[0] || null; }
      /* branche l'ajout au panier sur la variante choisie + met à jour le prix du bouton */
      function setAtc(vid, price) {
        if (atcForm && vid) { var idInput = atcForm.querySelector('input[name="id"]'); if (idInput) idInput.value = vid; }
        var ctaPrice = document.querySelector('.cta .cta-price'); if (ctaPrice) ctaPrice.textContent = eur(price);
      }
      var selectOpt = function (opt) {
        opts.forEach(function (o) { o.classList.remove('sel'); });
        opt.classList.add('sel');
        var price = parseFloat(opt.getAttribute('data-price')) || 0;
        var name = opt.getAttribute('data-name') || '';
        var vid = opt.getAttribute('data-variant-id');
        /* « Le Livre Seul » : la variante/prix dépendent du sélecteur Souple/Rigide */
        if (opt.querySelector('.as-variants')) {
          var sv = selectedVopt();
          if (sv) {
            vid = sv.getAttribute('data-vid') || vid;
            var pstr = sv.getAttribute('data-price');
            if (pstr) { var pn = parseFloat(pstr.replace(/[^\d,]/g, '').replace(',', '.')); if (!isNaN(pn)) price = pn; }
          }
        }
        var sp = document.querySelector('#asSticky .pr');
        if (sp) {
          if (sp.childNodes[0]) sp.childNodes[0].nodeValue = eur(price);
          var s = sp.querySelector('s'); if (s) s.textContent = name;
        }
        updateProgress(price);
        setAtc(vid, price);
      };
      opts.forEach(function (o) { o.addEventListener('click', function () { selectOpt(o); }); });
      /* clic sur une variante (Souple/Rigide) du « Livre Seul » */
      vopts.forEach(function (vo) {
        vo.addEventListener('click', function (e) {
          if (vo.hasAttribute('disabled')) return;
          e.stopPropagation();
          vopts.forEach(function (x) { x.classList.remove('sel'); });
          vo.classList.add('sel');
          var active = bundles.querySelector('.opt.sel');
          if (active && active.querySelector('.as-variants')) selectOpt(active);
        });
      });
      var preset = bundles.querySelector('.opt.sel');
      if (preset) selectOpt(preset);
    }

    /* --- Date de livraison estimée (aujourd'hui + N jours ouvrés) --- */
    var shipDate = document.getElementById('asShipDate');
    if (shipDate) {
      var days = parseInt(shipDate.getAttribute('data-days'), 10);
      if (isNaN(days)) days = 3;
      var d = new Date();
      var added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
      try {
        var s = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
        shipDate.textContent = s;
      } catch (e) {}
    }

    /* --- Galerie : clic vignette -> image (fondu enchaîné) ou vidéo (autoplay + boucle) --- */
    var mainMedia = document.getElementById('asGalMain');
    var galVideo = mainMedia ? mainMedia.querySelector('.gal-video') : null;
    var galBusy = false;
    var GAL_EASE = 'transform .38s cubic-bezier(.4,0,.2,1)';
    function galShowImage(src, dir) {
      if (!mainMedia) return;
      var img = mainMedia.querySelector('img');
      var videoOn = galVideo && galVideo.classList.contains('is-on');
      if (!img || (img.getAttribute('src') === src && !videoOn) || galBusy) return;
      galBusy = true;
      /* nouvelle image qui glisse latéralement ; si on vient de la vidéo, elle glisse par-dessus la vidéo qui sort */
      var fromRight = (dir !== 'prev');
      var outgoing = videoOn ? galVideo : img;
      var next = img.cloneNode(false);
      next.removeAttribute('srcset');
      next.className = 'gal-slide';
      if (videoOn) next.style.zIndex = '4';
      next.style.transform = 'translateX(' + (fromRight ? '100%' : '-100%') + ')';
      var reveal = function () {
        mainMedia.appendChild(next);
        outgoing.style.transition = GAL_EASE;
        outgoing.style.willChange = 'transform';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            next.style.transform = 'translateX(0)';
            outgoing.style.transform = 'translateX(' + (fromRight ? '-100%' : '100%') + ')';
          });
        });
        var done = function () {
          img.src = src; img.removeAttribute('srcset'); img.style.visibility = '';
          if (videoOn) {
            galVideo.classList.remove('is-on');
            try { galVideo.pause(); } catch (e) {}
            galVideo.style.transition = ''; galVideo.style.transform = ''; galVideo.style.willChange = '';
          } else {
            img.style.transition = ''; img.style.transform = ''; img.style.willChange = '';
          }
          if (next.parentNode) next.parentNode.removeChild(next);
          galBusy = false;
        };
        outgoing.addEventListener('transitionend', function (e) { if (e.propertyName === 'transform') done(); }, { once: true });
        setTimeout(done, 520);
      };
      next.addEventListener('load', reveal, { once: true });
      next.addEventListener('error', function () { img.src = src; img.removeAttribute('srcset'); galBusy = false; }, { once: true });
      next.src = src;
      if (next.complete) { next.dispatchEvent(new Event('load')); }
    }
    function galVideoPlay() {
      if (!galVideo) return;
      galVideo.muted = true; galVideo.setAttribute('muted', '');
      var p = galVideo.play(); if (p && p.catch) p.catch(function () {});
    }
    function galShowVideo(dir) {
      if (!mainMedia || !galVideo) return;
      if (galVideo.classList.contains('is-on')) { galVideoPlay(); return; }
      if (galBusy) return;
      galBusy = true;
      /* la vidéo glisse par-dessus l'image courante (même sens que les photos) */
      var fromRight = (dir !== 'prev');
      var img = mainMedia.querySelector('img');
      galVideo.style.transition = 'none';
      galVideo.style.transform = 'translateX(' + (fromRight ? '100%' : '-100%') + ')';
      galVideo.classList.add('is-on');
      try { galVideo.currentTime = 0; } catch (e) {}
      galVideoPlay();
      if (img) { img.style.transition = GAL_EASE; img.style.willChange = 'transform'; }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          galVideo.style.transition = GAL_EASE;
          galVideo.style.transform = 'translateX(0)';
          if (img) img.style.transform = 'translateX(' + (fromRight ? '-100%' : '100%') + ')';
        });
      });
      var done = function () {
        galVideo.style.transition = '';
        if (img) { img.style.visibility = 'hidden'; img.style.transition = ''; img.style.transform = ''; img.style.willChange = ''; }
        galVideoPlay();   /* relance après l'anim : le play() initial peut être interrompu par la transition (surtout au swipe) */
        galBusy = false;
      };
      galVideo.addEventListener('transitionend', function (e) { if (e.propertyName === 'transform') done(); }, { once: true });
      setTimeout(done, 520);
    }
    var galThumbs = Array.prototype.slice.call(root.querySelectorAll('.gal .thumb'));
    function galActivate(t, dir) {
      if (!mainMedia || !t) return;
      galThumbs.forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (t.hasAttribute('data-video')) { galShowVideo(dir); }
      else { galShowImage(t.getAttribute('data-src'), dir); }
    }
    galThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainMedia) return;
        var curIdx = galThumbs.indexOf(root.querySelector('.gal .thumb.on'));
        var newIdx = galThumbs.indexOf(t);
        var dir = (curIdx === -1 || newIdx >= curIdx) ? 'next' : 'prev';
        galActivate(t, dir);
      });
    });
    /* Mobile : balayer l'image principale au doigt (gauche = suivant, droite = précédent) */
    if (mainMedia && galThumbs.length > 1) {
      var swX = 0, swY = 0, swOn = false;
      mainMedia.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swOn = false; return; }
        swX = e.touches[0].clientX; swY = e.touches[0].clientY; swOn = true;
      }, { passive: true });
      mainMedia.addEventListener('touchend', function (e) {
        if (!swOn) return; swOn = false;
        var c = e.changedTouches[0];
        var dx = c.clientX - swX, dy = c.clientY - swY;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) || galBusy) return;
        var curIdx = galThumbs.indexOf(root.querySelector('.gal .thumb.on'));
        if (curIdx === -1) curIdx = 0;
        var n = galThumbs.length;
        var newIdx = dx < 0 ? (curIdx + 1) % n : (curIdx - 1 + n) % n;
        galActivate(galThumbs[newIdx], dx < 0 ? 'next' : 'prev');
      }, { passive: true });
    }

    /* Mini-vidéos des miniatures : lecture auto en boucle (mobile inclus) */
    var thumbVids = root.querySelectorAll('.thumb-vid');
    if (thumbVids.length) {
      var playThumbVids = function () { thumbVids.forEach(function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }); };
      playThumbVids();
      document.addEventListener('touchstart', playThumbVids, { once: true, passive: true });
    }

    /* --- FAQ accordéon --- */
    root.querySelectorAll('.qa').forEach(function (qa) {
      qa.addEventListener('click', function () {
        qa.classList.toggle('open');
        var pl = qa.querySelector('.pl');
        if (pl) pl.textContent = qa.classList.contains('open') ? '−' : '+';
      });
    });

    /* --- Carrousel vidéo (manège) --- */
    var storyStage = document.getElementById('asStories');
    var storyCards = storyStage ? Array.prototype.slice.call(storyStage.querySelectorAll('.as-story')) : [];
    var SN = storyCards.length, storyActive = 1, prevOff = [];
    function circOff(i, active, n) { var d = ((i - active) % n + n) % n; if (d > n / 2) d -= n; return d; }
    function renderStories() {
      // Desktop (>=750px) : affichage en ligne géré par le CSS. Le manège est réservé au mobile.
      // (Pour repasser le manège sur desktop : retirer ce bloc + les règles flat-row du pdp.css)
      if (window.innerWidth >= 750) {
        for (var d = 0; d < SN; d++) {
          var cc = storyCards[d];
          cc.style.transform = ''; cc.style.opacity = ''; cc.style.zIndex = ''; cc.style.transition = '';
          cc.classList.remove('big');
        }
        return;
      }
      var step = Math.round((storyCards[0] ? storyCards[0].offsetWidth : 148) * 0.9);
      for (var i = 0; i < SN; i++) {
        var card = storyCards[i];
        var off = circOff(i, storyActive, SN);
        var jumped = (prevOff[i] !== undefined) && Math.abs(off - prevOff[i]) > 1;
        if (jumped) { card.style.transition = 'none'; }
        var scale = (off === 0) ? 1.12 : 0.84;
        card.style.transform = 'translate(-50%, -50%) translateX(' + (off * step) + 'px) scale(' + scale + ')';
        card.style.zIndex = (off === 0) ? 3 : 2;
        card.style.opacity = (off === 0) ? 1 : 0.82;
        card.classList.toggle('big', off === 0);
        if (jumped) { void card.offsetWidth; card.style.transition = ''; }
        prevOff[i] = off;
      }
    }
    window.slideStories = function (dir) { if (!SN) return; storyActive = ((storyActive + dir) % SN + SN) % SN; renderStories(); };
    if (SN) {
      // Placement initial instantané (sinon la transition laisse les cartes à l'état de base)
      storyCards.forEach(function (c) { c.style.transition = 'none'; });
      renderStories();
      void storyStage.offsetWidth; // force le reflow
      storyCards.forEach(function (c) { c.style.transition = ''; }); // réactive pour le glissement aux flèches
      window.addEventListener('resize', renderStories, { passive: true });
    }

    /* --- Jeu du panier --- */
    var bagCount = 0, slotX = [-30, 2, 34], slotRot = [-9, 3, 11];
    window.bagCollect = function (btn) {
      if (btn.classList.contains('collected')) return;
      var tote = document.getElementById('asTote');
      if (!tote) return;
      var br = btn.getBoundingClientRect(), tr = tote.getBoundingClientRect();
      var slot = bagCount;
      var dx = (tr.left + tr.width / 2 + (slotX[slot] || 0)) - (br.left + br.width / 2);
      var dy = (tr.top + tr.height * 0.50) - (br.top + br.height / 2);
      var inner = btn.querySelector('.gi-in'); if (inner) inner.style.animation = 'none';
      btn.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.74) rotate(' + (slotRot[slot] || 0) + 'deg)';
      btn.style.zIndex = '0';
      btn.classList.add('collected');
      tote.classList.remove('bump'); void tote.offsetWidth; tote.classList.add('bump');
      bagCount++;
      var counter = document.getElementById('asBagCounter');
      if (counter) counter.textContent = bagCount + ' / 3 dans ton panier';
      if (bagCount >= 3) {
        setTimeout(function () {
          var st = document.getElementById('asBagStage'); if (st) st.classList.add('full');
          var dn = document.getElementById('asBagDone'); if (dn) dn.classList.add('show');
          var ad = document.getElementById('asBagAdd'); if (ad) ad.classList.add('show');
        }, 450);
      }
    };
    window.resetBag = function () {
      bagCount = 0;
      var counter = document.getElementById('asBagCounter');
      if (counter) counter.textContent = '0 / 3 dans ton panier';
      var st = document.getElementById('asBagStage'); if (st) st.classList.remove('full');
      var dn = document.getElementById('asBagDone'); if (dn) dn.classList.remove('show');
      var ad = document.getElementById('asBagAdd'); if (ad) ad.classList.remove('show');
      root.querySelectorAll('.gitem').forEach(function (it) {
        it.classList.remove('collected'); it.style.transform = ''; it.style.opacity = ''; it.style.zIndex = '';
        var inn = it.querySelector('.gi-in'); if (inn) inn.style.animation = '';
      });
      root.querySelectorAll('.bene').forEach(function (b) { b.classList.remove('got'); });
    };

    /* --- Vagues parallaxe + émojis qui tournent --- */
    var waveFront = root.querySelector('.wave-front');
    var waveFoam = root.querySelector('.wave-foam');
    var waveBack = root.querySelector('.wave-back');
    var vzEl = root.querySelector('.videozone');
    var sunSpin = document.getElementById('asSunSpin');
    var cocoSpin = document.getElementById('asCocoSpin');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && (waveFront || sunSpin)) {
      var curWave = window.scrollY, tgtWave = window.scrollY;
      window.addEventListener('scroll', function () { tgtWave = window.scrollY; }, { passive: true });
      (function tick() {
        curWave += (tgtWave - curWave) * 0.065;
        if (sunSpin) sunSpin.style.transform = 'rotate(' + (curWave * 0.2).toFixed(1) + 'deg)';
        if (cocoSpin) cocoSpin.style.transform = 'rotate(' + (curWave * 0.2).toFixed(1) + 'deg)';
        var q = (vzEl ? vzEl.clientWidth : 390) * 0.25;
        var pos = curWave * 0.26;
        if (waveFront) waveFront.style.backgroundPositionX = pos.toFixed(1) + 'px';
        if (waveFoam) waveFoam.style.backgroundPositionX = pos.toFixed(1) + 'px';
        if (waveBack) waveBack.style.backgroundPositionX = (pos + q).toFixed(1) + 'px';
        requestAnimationFrame(tick);
      })();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
